import {
  arrayBuilderYesNoSchema,
  arrayBuilderYesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';

export const arrayBuilderOptions = {
  arrayPath: 'additionalCertifyingOfficials',
  nounSingular: 'certifying official',
  nounPlural: 'certifying officials',
  required: false,
};

const additionalOfficialSummary = {
  uiSchema: {
    'view:additionalOfficialSummary': arrayBuilderYesNoUI(
      arrayBuilderOptions,
      {
        title: 'Do you have any additional certifying officials to add?',
        labels: {
          Y: 'Yes, I have certifying officials to add',
          N: `No, I don't have certifying officials to add`,
        },
        hint: () => null,
        errorMessages: {
          required: 'You must provide a response',
        },
      },
      {
        title: 'Do you have another additional certifying officials to add?',
        labels: {
          Y: 'Yes, I have another certifying officials to add',
          N: `No, I don't have another certifying officials to add`,
        },
        hint: () => null,
        errorMessages: {
          required: 'You must provide a response',
        },
      },
    ),
  },
  schema: {
    type: 'object',
    properties: {
      'view:introduction': { type: 'object', properties: {} },
      'view:additionalOfficialSummary': arrayBuilderYesNoSchema,
    },
    required: ['view:additionalOfficialSummary'],
  },
};

export { additionalOfficialSummary };
